"use client";

import { useAtomValue } from "jotai";
import { useSyncExternalStore } from "react";
import type { DiscoveryAuthUser } from "@/lib/getDiscoveryAuth";
import { discoveryUserAtom } from "./discoveryUser";
function subscribeNoop() {
  return () => {};
}

/**
 * Discovery user hydrated outside `"use cache"` (header / course route).
 * The server snapshot is always null so cached RSC never serializes PII.
 */
export function useDiscoveryUser() {
  const user = useAtomValue(discoveryUserAtom);
  const isClient = useSyncExternalStore(subscribeNoop, _temp, _temp2);
  return isClient ? user : null;
}
function _temp2() {
  return false;
}
function _temp() {
  return true;
}